import { useState } from "react";
import LoadBuildDetailsPanel from "../../loadBuildDetailsPanel";
import MaterialTable from "@material-table/core";
import useFilterState from "../../../hooks/useFilterState";
import { Button } from "@deere/fuel-react";
import _ from "lodash";

export const MaterialTableLoadBuild = (props) => {
  const {
    tableRef,
    pageSize,
    tableData,
    setPageNumber,
    handleClickOpen,
    tableName,
  } = props;

  const onPageChange = (e) => {
    setPageNumber(e);
  };

  const initialColumns = [
    {
      title: "Location",
      field: "from",
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Country",
      field: "country",
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Ship To",
      field: "to",
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "DIM (meter)",
      field: "diameter",
      sorting: false,
      filtering: false,
      cellStyle: {
        width: 110,
        maxWidth: 110,
        textAlign: "left",
      },
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Weight (Kg)",
      field: "weight",
      sorting: true,
      cellStyle: {
        textAlign: "left",
      },
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Comar No",
      field: "comarNo",
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Serial No",
      field: "serial",
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Model",
      field: "product",
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Ready For Pickup",
      field: "expectedPickup",
      sorting: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Status",
      field: "readyPickup",
      sorting: false,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "",
      field: "orderType",
      sorting: false,
      filtering: false,
      width: "5px",
      cellStyle: {
        width: "5px",
      },
      headerStyle: {
        width: "5px",
      },
    },
    {
      title: "OrderPath ID",
      field: "orderPathId",
      sorting: false,
      hidden: true,
    },
    {
      title: "",
      field: "buildId",
      sorting: false,
      filtering: false,
      width: "5px",
      cellStyle: {
        width: "5px",
      },
      headerStyle: {
        width: "5px",
      },
    },
    {
      title: "",
      field: "build",
      hidden: true,
      sorting: false,
      filtering: false,
    },
    {
      title: "",
      field: "freetext",
      hidden: true,
    },
    {
      title: "",
      field: "statusText",
      hidden: true,
    },
    {
      title: "",
      field: "orderYear",
      hidden: true,
    },
  ];

  // COLUMN-LEVEL FILTERING: useFilterState hook
  // This hook manages individual column filter values (search boxes in column headers)
  // Different from useComarFilter which handles navigation-based filtering from urgent actions
  // - tableName: "LoadBuild" - unique identifier for localStorage persistence
  // - initialColumns: Column configuration with filter settings
  // Returns: [updatedColumns, filterChangeHandler] for MaterialTable
  const [columnsWithFilter, handleFilterChange] = useFilterState(
    tableName,        // Unique table identifier for filter persistence
    initialColumns    // Initial column configuration
  );

  const [selectedRowIds, setSelectedRowIds] = useState(new Set());

  return (
    <>
      <MaterialTable
        tableRef={tableRef}
        localization={{
          body: {
            emptyDataSourceMessage: (
              <h6 className=" left-[45%] absolute top-[40%] text-center">
                No records to display
              </h6>
            ),
          },
          pagination: {
            labelRowsPerPage: "Orders Per Page",
            labelRowsSelect: "Orders",
          },
        }}
        options={{
          rowStyle: {
            fontSize: 10,
          },
          selection: true,
          search: false,
          showTitle: false,
          grouping: false,
          sorting: true,
          filtering: true,
          draggable: false,
          pageSize: 100,
          maxBodyHeight: 600,
          headerStyle: {
            backgroundColor: "#367c2b",
            fontWeight: "400",
            color: "white",
            position: "sticky",
            top: 0,
            zIndex: 10,
          },
          tableContainerStyle: {
            maxHeight: 600,
            overflow: "auto",
          },
          pageSizeOptions: [100, 500, 1000],
          filterCellStyle: {
            flex: 1,
          },
        }}
        columns={columnsWithFilter.map((col, index) => {
          if (
            col.tableData?.filterValue == "" ||
            col.tableData?.filterValue == null ||
            col.tableData?.filterValue == undefined
          ) {
            let colWithoutDefaultFilter = _.omit(
              col,
              "defaultFilter",
              "tableData.filterValue"
            );
            return colWithoutDefaultFilter;
          } else {
            return {
              ...col,
              defaultFilter: col.tableData?.filterValue,
            };
          }
        })}
        onSelectionChange={(selectedRows) => {
          const newSelectedIds = new Set(
            selectedRows.map((row) => row.orderPathId)
          );
          setSelectedRowIds(newSelectedIds);
        }}
        data={tableData.map((row) => ({
          ...row,
          tableData: {
            ...(row.tableData || {}),
            checked: selectedRowIds.has(row.orderPathId),
          },
        }))}
        detailPanel={(rowData) => {
          return <LoadBuildDetailsPanel rowData={rowData} />;
        }}
        onRowClick={(event, rowData, togglePanel) => togglePanel()}
        onChangePage={(e) => onPageChange(e)}
        onFilterChange={(filters) => {
          // Create a map of current filters for quick lookup
          const filterMap = new Map();
          filters.forEach((filter) => {
            filterMap.set(filter.column.tableData.id, filter.value);
          });

          // Iterate over all columns to ensure each one is checked if the value is present in the filter map
          columnsWithFilter.forEach((col, columnId) => {
            const newValue = filterMap.get(columnId) || ""; // Default to empty string if not found

            // Update the filter state for each column
            handleFilterChange(columnId, newValue);
          });
        }}
        actions={[
          {
            tooltip: "Load Build",
            icon: () => (
              <Button variant="primary" size="small">
                Load Build
              </Button>
            ),
            onClick: (evt, data) => {
              handleClickOpen(data);
            },
          },
        ]}
      />
    </>
  );
};
